import React from 'react';

import Chip from '@mui/material/Chip';

import { TicketCategory } from 'stores/TicketTypeStoreAdapter';

const TicketCategoryColor: Record<TicketCategory, string> = {
  TASK: '#1976d2',
  APPROVAL: '#7b1fa2',
};

type Props = {
  ticketCategory: TicketCategory;
  size?: 'small' | 'medium';
};

/** チケット分類（タスク/承認）を表示するチップ */
const TicketCategoryChip: React.FC<Props> = ({ ticketCategory, size = 'small' }) => {
  const color = TicketCategoryColor[ticketCategory];
  return (
    <Chip
      label={TicketCategory[ticketCategory]}
      size={size}
      sx={{
        color: '#fff',
        backgroundColor: color,
        fontWeight: 400,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default TicketCategoryChip;
